<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import type { IProjectAction } from "../../entities/project-action.ts";
    const dispatch = createEventDispatcher();

    export let open = false;
    export let action: IProjectAction;

    export function formatDateForInput(
        date: Date | string | null | undefined,
    ): string {
        if (!date) return "";
        const d = typeof date === "string" ? new Date(date) : date;
        return d.toISOString().split("T")[0];
    }

    export function parseInputToDate(str: string): Date | null {
        if (!str) return null; // if input is empty, return null
        return new Date(`${str}T00:00:00`);
    }

    let dataInizioStr, dataFineStr, dataStatoStr;

    $: dataInizioStr = formatDateForInput(action?.dataInizio);
    $: dataFineStr = formatDateForInput(action?.dataFine);
    $: dataStatoStr = formatDateForInput(action?.dataStato);

    function close() {
        dispatch("close");
    }

    function save() {
        action.dataInizio = parseInputToDate(dataInizioStr);
        action.dataFine = parseInputToDate(dataFineStr);
        action.dataStato = parseInputToDate(dataStatoStr);
        dispatch("save", action);
        close();
    }
</script>

{#if open}
    <div class="modal is-active">
        <div class="modal-background" on:click={close}></div>

        <div
            class="modal-card"
            style="width: 700px; max-height: 80vh; overflow-y: auto;"
        >
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {action?.codiceAzione
                        ? "Modifica azione CRM (" + action.codiceAzione + ")"
                        : "Crea nuova azione CRM" }
                </p>

                <button class="delete" aria-label="close" on:click={close}
                ></button>
            </header>

            <section class="modal-card-body">
                
                {#if action.parentAction}
                <div class="field">
                    <label class="label" for="s_posizione">Posizione</label>
                    <div class="control has-addons">
                        <button
                            type="button"
                            class="button {action.posizione === 'prima'
                                ? 'is-link is-selected'
                                : ''}"
                            on:click={() => (action.posizione = "prima")}
                        >
                            Prima azione ERP ({action.parentAction})
                        </button>
                        <button
                            type="button"
                            class="button {action.posizione === 'dopo'
                                ? 'is-link is-selected'
                                : ''}"
                            on:click={() => (action.posizione = "dopo")}
                        >
                            Dopo azione ERP ({action.parentAction})
                        </button>
                    </div>
                </div>
                {/if}

                <div class="field">
                    <label class="label" for="s_stato">Stato</label>
                    <div class="control">
                        <input
                            id="s_stato"
                            class="input"
                            type="text"
                            bind:value={action.stato}
                            placeholder="Stato"
                            required
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="titolo">Titolo</label>
                    <div class="control">
                        <input
                            id="titolo"
                            class="input"
                            type="text"
                            bind:value={action.titolo}
                            placeholder="Titolo azione"
                            required
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="s_descrizione_azione"
                        >Descrizione Azione</label
                    >
                    <div class="control">
                        <textarea
                            id="s_descrizione_azione"
                            class="textarea"
                            bind:value={action.descrizioneAzione}
                            placeholder="Descrizione azione"
                            required
                        ></textarea>
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="s_hub">Hub</label>
                    <div class="control">
                        <input
                            id="s_hub"
                            class="input"
                            type="text"
                            bind:value={action.hub}
                            placeholder="Hub"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="s_note">Note</label>
                    <div class="control">
                        <textarea
                            id="s_note"
                            class="textarea"
                            bind:value={action.riferimentoNote}
                            placeholder="Riferimento Note"
                            required
                        ></textarea>
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="m_ore">Ore</label>
                    <div class="control">
                        <input
                            id="m_ore"
                            class="input"
                            type="number"
                            min="0"
                            step="0.01"
                            bind:value={action.ore}
                            placeholder="Ore"
                            required
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="s_tipologia_ore"
                        >Tipologia Ore</label
                    >
                    <div class="control">
                        <input
                            id="s_tipologia_ore"
                            class="input"
                            type="text"
                            bind:value={action.tipologiaOre}
                            placeholder="Tipologia ore"
                            required
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="s_descr_tipo_intervento"
                        >Descrizione Tipo Intervento</label
                    >
                    <div class="control">
                        <input
                            id="s_descr_tipo_intervento"
                            class="input"
                            type="text"
                            bind:value={action.descrTipoIntervento}
                            placeholder="Descrizione tipo intervento"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="s_uff_competenza"
                        >Ufficio Competenza</label
                    >
                    <div class="control">
                        <input
                            id="s_uff_competenza"
                            class="input"
                            type="text"
                            bind:value={action.uffcompetenza}
                            placeholder="Ufficio competenza"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="s_stato_azione"
                        >Stato Azione</label
                    >
                    <div class="control">
                        <input
                            id="s_stato_azione"
                            class="input"
                            type="text"
                            bind:value={action.statoazione}
                            placeholder="Stato azione"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="d_stato">Data Stato</label>
                    <div class="control">
                        <input
                            id="d_stato"
                            class="input"
                            type="date"
                            bind:value={dataStatoStr}
                            required
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="b_pianificato">Pianificato</label>
                    <div class="control">
                        <input
                            id="b_pianificato"
                            class="input"
                            type="text"
                            bind:value={action.pianificato}
                            placeholder="Pianificato"
                            required
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="b_erogato">Erogato</label>
                    <div class="control">
                        <input
                            id="b_erogato"
                            class="input"
                            type="text"
                            bind:value={action.erogato}
                            placeholder="Erogato"
                            required
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="b_annullato">Annullato</label>
                    <div class="control">
                        <input
                            id="b_annullato"
                            class="input"
                            type="text"
                            bind:value={action.annullato}
                            placeholder="Annullato"
                            required
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="d_inizio">Data Inizio</label>
                    <div class="control">
                        <input
                            id="d_inizio"
                            class="input"
                            type="date"
                            bind:value={dataInizioStr}
                            required
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="d_fine">Data Fine</label>
                    <div class="control">
                        <input
                            id="d_fine"
                            class="input"
                            type="date"
                            bind:value={dataFineStr}
                            required
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="i_partecipanti_attesi"
                        >Partecipanti Attesi</label
                    >
                    <div class="control">
                        <input
                            id="i_partecipanti_attesi"
                            class="input"
                            type="number"
                            min="0"
                            bind:value={action.partecipantiAttesi}
                            placeholder="Partecipanti attesi"
                            required
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="m_costo_std_1">Costo Std 1</label>
                    <div class="control">
                        <input
                            id="m_costo_std_1"
                            class="input"
                            type="number"
                            min="0"
                            step="0.01"
                            bind:value={action.costoStandard1}
                            placeholder="Costo standard 1"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="m_costo_std_2">Costo Std 2</label>
                    <div class="control">
                        <input
                            id="m_costo_std_2"
                            class="input"
                            type="number"
                            min="0"
                            step="0.01"
                            bind:value={action.costoStandard2}
                            placeholder="Costo standard 2"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="m_budget">Budget</label>
                    <div class="control">
                        <input
                            id="m_budget"
                            class="input"
                            type="number"
                            min="0"
                            step="0.01"
                            bind:value={action.budget}
                            placeholder="Budget"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="b_monitoraggio_effettuato"
                        >Monitoraggio Effettuato</label
                    >
                    <div class="control">
                        <input
                            id="b_monitoraggio_effettuato"
                            class="input"
                            type="text"
                            bind:value={action.monitoraggioEffettuato}
                            placeholder="Monitoraggio effettuato"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="m_ore_finali">Ore Finali</label>
                    <div class="control">
                        <input
                            id="m_ore_finali"
                            class="input"
                            type="number"
                            min="0"
                            step="0.01"
                            bind:value={action.oreFinali}
                            placeholder="Ore finali"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="i_partecipanti_finali"
                        >Partecipanti Finali</label
                    >
                    <div class="control">
                        <input
                            id="i_partecipanti_finali"
                            class="input"
                            type="number"
                            min="0"
                            bind:value={action.partecipantiFinali}
                            placeholder="Partecipanti finali"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="m_totale_rendicontato"
                        >Totale Rendicontato</label
                    >
                    <div class="control">
                        <input
                            id="m_totale_rendicontato"
                            class="input"
                            type="number"
                            min="0"
                            step="0.01"
                            bind:value={action.totalerendicontato}
                            placeholder="Totale rendicontato"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="s_tipo_rendiconto"
                        >Tipo Rendiconto</label
                    >
                    <div class="control">
                        <input
                            id="s_tipo_rendiconto"
                            class="input"
                            type="text"
                            bind:value={action.tipoRendiconto}
                            placeholder="Tipo rendiconto"
                            required
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="m_decurtazione"
                        >Decurtazione</label
                    >
                    <div class="control">
                        <input
                            id="m_decurtazione"
                            class="input"
                            type="number"
                            step="0.01"
                            bind:value={action.decurtazione}
                            placeholder="Decurtazione"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="s_ragsoc1"
                        >Ragione Sociale 1</label
                    >
                    <div class="control">
                        <input
                            id="s_ragsoc1"
                            type="text"
                            bind:value={action.ragsoc1}
                            placeholder="Ragione Sociale 1"
                            class="input"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="s_ragsoc2"
                        >Ragione Sociale 2</label
                    >
                    <div class="control">
                        <input
                            id="s_ragsoc2"
                            type="text"
                            bind:value={action.ragsoc2}
                            placeholder="Ragione Sociale 2"
                            class="input"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="s_ragsoc3"
                        >Ragione Sociale 3</label
                    >
                    <div class="control">
                        <input
                            id="s_ragsoc3"
                            type="text"
                            bind:value={action.ragsoc3}
                            placeholder="Ragione Sociale 3"
                            class="input"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="s_ragsoc4"
                        >Ragione Sociale 4</label
                    >
                    <div class="control">
                        <input
                            id="s_ragsoc4"
                            type="text"
                            bind:value={action.ragsoc4}
                            placeholder="Ragione Sociale 4"
                            class="input"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="s_ragsoc5"
                        >Ragione Sociale 5</label
                    >
                    <div class="control">
                        <input
                            id="s_ragsoc5"
                            type="text"
                            bind:value={action.ragsoc5}
                            placeholder="Ragione Sociale 5"
                            class="input"
                        />
                    </div>
                </div>

                <div class="field">
                    <label class="label" for="s_ragsoc6"
                        >Ragione Sociale 6</label
                    >
                    <div class="control">
                        <input
                            id="s_ragsoc6"
                            type="text"
                            bind:value={action.ragsoc6}
                            placeholder="Ragione Sociale 6"
                            class="input"
                        />
                    </div>
                </div>
            </section>

            <footer class="modal-card-foot">
                <button class="button is-primary" on:click={save}>Salva</button>
                <button class="button" on:click={close}>Annulla</button>
            </footer>
        </div>
    </div>
{/if}
